export enum AuthorType {
	User = 'user',
	Organization = 'organization',
	Group = 'group',
	TSPlayer = '360Player',
	Account = 'account',
}

export interface Author {
	type: AuthorType;
	name: string;
	profileImageUrl: string;
	primaryColor?: string;
	initials: string;
	firstName?: string;
	lastName?: string;
}
